/**
 * Follow-mode state machine (spec 02). Pure — no Leaflet — so it can be unit
 * tested in isolation. MapController drives it and applies the effects.
 *
 * Rules:
 *  - followTap  → following; center on fix at current zoom
 *  - new fix    → if following, recenter (no animation)
 *  - zoom change→ record lastUserZoom; NEVER exits following (sticky zoom)
 *  - user pan   → off
 *  - followTap when off → resume at lastUserZoom
 */

export type FollowMode = 'off' | 'following';

export interface FollowState {
  mode: FollowMode;
  lastUserZoom: number;
}

export type FollowEvent =
  | { type: 'followTap'; currentZoom: number }
  | { type: 'userPan' }
  | { type: 'zoomChange'; zoom: number };

export function initialFollowState(zoom: number): FollowState {
  return { mode: 'off', lastUserZoom: zoom };
}

export function reduceFollow(state: FollowState, event: FollowEvent): FollowState {
  switch (event.type) {
    case 'followTap':
      // Resume at last user zoom if we already have one, else the tap's zoom.
      return { mode: 'following', lastUserZoom: state.lastUserZoom };
    case 'zoomChange':
      // Sticky zoom: record it, but zooming never breaks follow.
      return { ...state, lastUserZoom: event.zoom };
    case 'userPan':
      return { ...state, mode: 'off' };
    default:
      return state;
  }
}
